<div *ngIf="addresses.length" data-cy="content">

  <h4 data-cy='account-header' class="heading__regular--xs udex-mb-20">{{'cart.account' | cxTranslate}}</h4>

  <div class="row">
    <dcp-cart-header-information-item
      data-cy="buyer"
      class="col-12 col-sm-6 udex-mb-32"
      [showSeparator]="true"
      [titleText]="isCurrentUserIndividual ? 'cart.personalDetails' : 'cart.buyerDetails'"
      [firstName]="getInfo(addressUsage.MAIN_CONTACT)[addressParams.FIRST_NAME]"
      [lastName]="getInfo(addressUsage.MAIN_CONTACT)[addressParams.LAST_NAME]"
      [email]="getInfo(addressUsage.MAIN_CONTACT)[addressParams.EMAIL]"
      [cartIsLoading]="cartIsLoading"
    ></dcp-cart-header-information-item>

    <ng-container *ngIf="!isCurrentUserIndividual">
      <dcp-cart-header-information-item
        data-cy="it-contact"
        class="col-12 col-sm-6 udex-mb-32"
        [showSeparator]="true"
        titleText="cart.technicalContact"
        [firstName]="getInfo(addressUsage.IT_CONTACT)[addressParams.FIRST_NAME]"
        [lastName]="getInfo(addressUsage.IT_CONTACT)[addressParams.LAST_NAME]"
        [email]="getInfo(addressUsage.IT_CONTACT)[addressParams.EMAIL]"
        [cartIsLoading]="cartIsLoading"
      ></dcp-cart-header-information-item>

      <dcp-cart-header-information-item
        data-cy="sold-to"
        class="col-12 col-sm-6 udex-mb-32"
        [showSeparator]="true"
        titleText="cart.companyDetails"
        [companyName]="getInfo(addressUsage.SOLD_TO)[addressParams.COMPANY_NAME]"
        [industry]="getInfo(addressUsage.SOLD_TO)[addressParams.INDUSTRY]"
        [formattedAddress]="getInfo(addressUsage.SOLD_TO)[addressParams.FORMAT_ADDRESS]"
        [country]="getInfo(addressUsage.SOLD_TO)[addressParams.COUNTRY]"
        [cartIsLoading]="cartIsLoading"
      ></dcp-cart-header-information-item>

      <dcp-cart-header-information-item
        data-cy="ship-to"
        class="col-12 col-sm-6 udex-mb-32"
        [showSeparator]="true"
        titleText="cart.primaryAccessLocation"
        [companyName]="getInfo(addressUsage.SHIP_TO)[addressParams.COMPANY_NAME]"
        [industry]="getInfo(addressUsage.SHIP_TO)[addressParams.INDUSTRY]"
        [formattedAddress]="getInfo(addressUsage.SHIP_TO)[addressParams.FORMAT_ADDRESS]"
        [country]="getInfo(addressUsage.SHIP_TO)[addressParams.COUNTRY]"
        [cartIsLoading]="cartIsLoading"
      ></dcp-cart-header-information-item>
    </ng-container>
  </div>

  <h4 data-cy='billing-header'
      class="heading__regular--xs udex-mb-20">{{ 'cart.billing' | cxTranslate}}</h4>

  <div class="row">
    <dcp-cart-header-information-item
      data-cy="payment-type"
      class="col-12 col-sm-6 udex-mb-32"
      titleText="cart.paymentMethod"
      [paymentName]="paymentType?.displayName"
      [cartIsLoading]="cartIsLoading"
    ></dcp-cart-header-information-item>

    <dcp-cart-header-information-item
      data-cy="invoice-recipient"
      class="col-12 col-sm-6 udex-mb-32"
      titleText="cart.billTo"
      [firstName]="getInfo(addressUsage.INVOICE_RECIPIENT)[addressParams.FIRST_NAME]"
      [lastName]="getInfo(addressUsage.INVOICE_RECIPIENT)[addressParams.LAST_NAME]"
      [email]="getInfo(addressUsage.INVOICE_RECIPIENT)[addressParams.EMAIL]"
      [cartIsLoading]="cartIsLoading"
    ></dcp-cart-header-information-item>

    <dcp-cart-header-information-item
      data-cy="tax-doc"
      class="col-12 col-sm-6 udex-mb-32 order-1 order-sm-0"
      titleText="cart.taxExemptionDoc"
      [documents]="documents"
      [cartIsLoading]="cartIsLoading"
    ></dcp-cart-header-information-item>

    <dcp-cart-header-information-item
      data-cy="billing-address"
      class="col-12 col-sm-6 udex-mb-32"
      titleText="cart.billingAddress"
      [companyName]="getInfo(addressUsage.BILL_TO)[addressParams.COMPANY_NAME]"
      [formattedAddress]="getInfo(addressUsage.BILL_TO)[addressParams.FORMAT_ADDRESS]"
      [country]="getInfo(addressUsage.BILL_TO)[addressParams.COUNTRY]"
      [cartIsLoading]="cartIsLoading"
    ></dcp-cart-header-information-item>
  </div>

</div>
